module.exports = __webpack_public_path__ + "static/media/code.fe174ae6.svg";